import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Assets
import './NavBar.scss';
import { ReactComponent as MoreIcon } from '../../../../assets/images/svg/more.svg';
import classNames from 'classnames';
import { checkActivePath } from '../../../../helpers/utils';
import DropdownMenu from '../../../DropdownMenu/DropdownMenu';
import { IS_SHOW_TV_CONTENT } from '../../../../constants/configuration';
import { getTvCaregories } from '../../../../../features/video-configuration/videoConfigurationSlice';

const RecursiveRoutes = (item, index) => {
  const location = useLocation();

  return (
    (item.routes?.length && (
      <li key={index} className={item.class || null}>
        <Link to="#">
          <MoreIcon />
        </Link>
        <ul className="NavBar__dropdown">{item.routes.map(RecursiveRoutes)}</ul>
      </li>
    )) || (
      <li key={index} className={item.class || null}>
        <NavLink
          exact
          to={item.path}
          className={checkActivePath(item.activePathNames, location.pathname) ? 'active' : ''}
        >
          {item.title}{' '}
        </NavLink>
      </li>
    )
  );
};

const NavBar = ({ navBarRoutes, navBarClassName, isVisible }) => {
  const { t } = useTranslation();
  const tvCategories = useSelector(getTvCaregories);

  return (
    isVisible && (
      <nav className={classNames('NavBar', navBarClassName)}>
        {!!navBarRoutes?.length && (
          <ul>
            {navBarRoutes.map(RecursiveRoutes)}
            {IS_SHOW_TV_CONTENT ? (
              <li className="NavBar__more">
                <DropdownMenu
                  items={tvCategories.filter(
                    (i) =>
                      i.id !== 'kinohity' &&
                      i.id !== 'boyovyky' &&
                      i.id !== 'komedii' &&
                      i.id !== 'dramy' &&
                      i.id !== 'dokumentalni'
                  )}
                  extraItems={t('header.additionalItems', {
                    returnObjects: true
                  })}
                />
              </li>
            ) : null}
          </ul>
        )}
      </nav>
    )
  );
};

NavBar.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  navBarRoutes: PropTypes.array.isRequired,
  navBarClassName: PropTypes.string
};

export default React.memo(NavBar);
